import { render } from "./gsgg.vue?vue&type=template&id=72c37e4c&scoped=true&ts=true"
import script from "./gsgg.vue?vue&type=script&lang=ts"
export * from "./gsgg.vue?vue&type=script&lang=ts"

import "./gsgg.vue?vue&type=style&index=0&id=72c37e4c&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c37e4c"]])

export default __exports__